<script>
  import tipoUsuario from '~js/tipo-usuario';
  import ModalAtendimento from '~componentes/ModalAtendimento.vue';

  export default {
    components: { ModalAtendimento },
    data() {
      return {
        usuario: this.$storage.usuario(),
        configuracao: this.$storage.configuracao(),
        modalAtendimento: false,
      }
    },
    computed: {
      exibirLinksNavbar() {
        return this.$route.name.startsWith('transparencia') || this.$route.name.startsWith('editais');
      },
      fusp() {
        return ((this.configuracao.abreviaturaFundacao.toUpperCase() === 'FUSP') && (this.usuario.tipoUsuario == tipoUsuario.Coordenador));
      },
      fau() {
        return ((this.configuracao.abreviaturaFundacao.toUpperCase() === 'FAU') && (this.usuario.tipoUsuario == tipoUsuario.Coordenador));
      },
      manuais() {
        return ((this.configuracao.urlManuais != '') && (this.usuario.tipoUsuario == tipoUsuario.Coordenador));
      },
    },
    methods: {
      SmoothlyMenu() {
        if (!$('body').hasClass('mini-navbar') || $('body').hasClass('body-small')) {
          // Hide menu in order to smoothly turn on when maximize menu
          $('#side-menu').hide();
          // For smoothly turn on menu
          setTimeout(
            function () {
              $('#side-menu').fadeIn(400);
            }, 200);
        } else if ($('body').hasClass('fixed-sidebar')) {
          $('#side-menu').hide();
          setTimeout(
            function () {
              $('#side-menu').fadeIn(400);
            }, 100);
        } else {
          // Remove all inline style from jquery fadeIn function to reset menu state
          $('#side-menu').removeAttr('style');
        }
      },
      abrirURLManuais() {
        window.open(this.configuracao.urlManuais, "_blank");
      },
      async mostrarModalAtendimento() {
        if (this.$refs.modalAtendimentoNav)
            await this.$refs.modalAtendimentoNav.carregaAtendimentos();    
        this.modalAtendimento = true;
      },
      fecharModalAtendimento() {
        this.modalAtendimento = false;
      },
    },
    mounted() {
      let _this = this;
      
      _this.$nextTick(function () {
        // Close menu in canvas mode
        $('.close-canvas-menu').on('click', function () {
          $('body').toggleClass('mini-navbar');
          _this.SmoothlyMenu();
        });

        $('.navbar-minimalize').on('click', function () {
           $('body').toggleClass('mini-navbar');
          _this.SmoothlyMenu();
        });
      });
    }
  }
</script>
<template>
  <div>
      <modal-atendimento ref="modalAtendimentoNav"
                         :mostrar="modalAtendimento"
                         @fechado="fecharModalAtendimento">
      </modal-atendimento>

    <div class="row border-bottom">
      <nav class="navbar navbar-static-top" role="navigation" style="margin-bottom: 0">
        <div class="navbar-header">
          <button type="button" class="navbar-minimalize minimalize-styl-2 btn btn-primary"><i class="fa fa-bars"></i> </button>
        </div>
        <ul class="nav navbar-top-links navbar-right" v-show="!exibirLinksNavbar">
          <li v-if="fau">
            <a @click.prevent="mostrarModalAtendimento">
              <i class="fa fa-ticket"></i> Atendimento
            </a>
          </li>
          <li v-if="manuais">
            <a @click.prevent="abrirURLManuais">
              <i class="fa fa-file-text-o"></i> {{this.configuracao.labelManuais}}
            </a>
          </li>
          <li v-show="fusp">
            <a href="https://www.fusp.org.br/circulares" target="_blank">
              <i class="fa fa-file-text-o"></i> Normas - FUSP
            </a>
          </li>
          <li>
            <a @click.prevent="$events.$emit('logout')">
              <i class="fa fa-sign-out"></i> Sair
            </a>
          </li>
        </ul>
      </nav>
    </div>
  </div>
</template>



// WEBPACK FOOTER //
// FrontEnd/componentes/Navbar.vue